var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang
    ? _c("div", { staticClass: "estate-data" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row align-items-center " },
            [
              _c(
                "div",
                { staticClass: "col-auto p-2" },
                [
                  _c(
                    "div",
                    { staticClass: "estate-price" },
                    [
                      _c("span", {
                        staticClass: "current-price",
                        domProps: { innerHTML: _vm._s(_vm.estate.price) }
                      }),
                      _vm._v(" "),
                      _vm.estate.price_alternative
                        ? _c("span", {
                            staticClass: "current-price-euro",
                            domProps: {
                              innerHTML: _vm._s(_vm.estate.price_alternative)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("estate-discount", { attrs: { estate: _vm.estate } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("estate-card-data", { attrs: { estate: _vm.estate } }),
                  _vm._v(" "),
                  _vm.estate.estate_other_contract
                    ? _c("div", { staticClass: "other-contract" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.estate.estate_other_contract.detail_url
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "other-contract-contract" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.lang.labels.also) +
                                    " " +
                                    _vm._s(
                                      _vm.$root.lang.words.contract[
                                        _vm.estate.estate_other_contract
                                          .contract
                                      ]
                                    ) +
                                    "  "
                                ),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.estate.estate_other_contract.price
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("masked-image", {
                                  staticClass: "costs-details",
                                  attrs: {
                                    src: "/img/icons/linear-arrow-right.svg",
                                    width: "13",
                                    height: "13"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$root.is_mobile
                ? [
                    _c("div", { staticClass: "col-auto" }, [
                      _c("h1", { staticClass: "estate-title" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.estate.title) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("h2", { staticClass: "estate-subtitle" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.estate.subtitle) +
                            "\n                    "
                        )
                      ])
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-auto col-lg-auto estate-actions" },
                [
                  _vm.backLink
                    ? _c(
                        "div",
                        { staticClass: "back-link" },
                        [
                          _c("masked-image", {
                            attrs: { src: "/img/icons/arrow-back-list.svg" }
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "back",
                              attrs: { href: _vm.backLink }
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.lang.labels.back))])]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$root.is_mobile
                    ? [_c("estate-actions", { attrs: { estate: _vm.estate } })]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "share-button" },
                    [
                      _c("estate-share", {
                        attrs: {
                          estate: _vm.estate,
                          "estate-id": _vm.estate.id,
                          "agency-id": _vm.estate.agency
                            ? _vm.estate.agency.id
                            : null,
                          type: _vm.estate.ad_type
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }